import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  status?: ReactNode;
  actions?: ReactNode;
  kicker?: string;
}

export function PageHeader({ title, subtitle, status, actions, kicker }: PageHeaderProps) {
  return (
    <header className="page-header" data-testid="page-header">
      <div className="page-header__text">
        {kicker && <p className="page-header__kicker">{kicker}</p>}
        <div className="page-header__title-row">
          <h1>{title}</h1>
          {status}
        </div>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
